import { StructuredContentDto } from "../../api/schema/openapi";
import { ChatMessage as ChatMessageType } from "../../types";

export const getMessageKey = (m: ChatMessageType, idx: number): string => {
  const anyMsg: any = m as any;
  if (typeof anyMsg.id === "string" && anyMsg.id) return anyMsg.id;
  const preview = typeof anyMsg.content === "string" ? anyMsg.content.slice(0, 30) : "";
  return `${m.user}-${preview}-${idx}`;
};

export const parseStructuredFromString = (text?: string): StructuredContentDto | undefined => {
  if (!text || typeof text !== "string") return undefined;
  const trimmed = text.trim();
  if (!trimmed.startsWith("{")) return undefined;
  try {
    const parsed = JSON.parse(trimmed);
    if (parsed && typeof parsed === "object" && Array.isArray(parsed.blocks)) {
      return parsed as StructuredContentDto;
    }
  } catch {
    // ignore
  }
  return undefined;
};

export const areMessagesEqual = (a: ChatMessageType, b: ChatMessageType): boolean => {
  const ax: any = a as any;
  const bx: any = b as any;
  if (ax.user !== bx.user) return false;
  if (ax.user === "user") return ax.content === bx.content;
  if (ax.id || bx.id) {
    return ax.id === bx.id && ax.isError === bx.isError && ax.content === bx.content;
  }
  return ax.isError === bx.isError && ax.content === bx.content;
};
